module.exports = __webpack_public_path__ + "static/img/no-coupon.cd4947fd.png";